import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CalendarDaysIcon, MegaphoneIcon, UserIcon, VideoIcon } from 'lucide-react';
import { ecosystemNodes, EcoNodeKey } from '../data/ecosystem';
import { Logo } from './Logo';
import { Reveal } from './Reveal';
const icons: Record<EcoNodeKey, typeof UserIcon> = {
  you: UserIcon,
  events: CalendarDaysIcon,
  brands: MegaphoneIcon,
  creators: VideoIcon
};
const placement: Record<EcoNodeKey, {
  cls: string;
  side: 'left' | 'right';
}> = {
  you: {
    cls: 'md:col-start-1 md:row-start-1',
    side: 'left'
  },
  events: {
    cls: 'md:col-start-3 md:row-start-1',
    side: 'right'
  },
  brands: {
    cls: 'md:col-start-1 md:row-start-2',
    side: 'left'
  },
  creators: {
    cls: 'md:col-start-3 md:row-start-2',
    side: 'right'
  }
};
export function Ecosystem() {
  return <section id="connect" className="py-20 lg:py-24" aria-labelledby="connect-title" data-id="element-60" data-mp="27f8v29zon3hz">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-61" data-mp="22ge94z6f4ytn">
        <Reveal className="grid gap-5 lg:grid-cols-12 lg:items-end" data-id="element-62" data-mp="22gxg5kuj62sw">
          <h2 id="connect-title" className="font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl lg:col-span-6" data-id="element-63" data-mp="2m5ete0nmyt3y">
            Where you, events and brands meet.
          </h2>
          <p className="text-lg leading-relaxed text-muted lg:col-span-5 lg:col-start-8" data-id="element-64" data-mp="2c9l9txbi1zco">
            AVEGA doesn't organize events. It links the events you already go to with the brands that support them and
            the creators you follow.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-3 md:grid-cols-[1fr_180px_1fr] md:grid-rows-2 lg:grid-cols-[1fr_220px_1fr]" data-id="element-65" data-mp="39txu9v4cw3m0">
          <div className="leaf-lg order-first flex flex-col items-center justify-center bg-forest px-6 py-10 text-center md:order-none md:col-start-2 md:row-span-2 md:row-start-1" data-id="element-66" data-mp="2v6300aap9r6t">
            <Logo tone="light" data-id="element-67" data-mp="3nu8lx0dhpm88" />
            <p className="mt-2 text-[10px] font-semibold tracking-[0.25em] text-white/50" data-id="element-68" data-mp="3nt77qn16gjma">PLATFORM</p>
            <p className="mt-5 text-sm font-semibold text-mint" data-id="element-69" data-mp="3snl9d76fnmze">Scan · Engage · Convert</p>
          </div>

          {ecosystemNodes.map(n => {
          const Icon = icons[n.key];
          const {
            cls,
            side
          } = placement[n.key];
          const highlight = n.key === 'you';
          return <article key={n.key} className={`leaf-md flex flex-col p-6 lg:p-8 ${cls} ${highlight ? 'bg-mint-soft' : 'bg-white ring-1 ring-line'}`} data-id="element-70" data-mp="3ohy3seinckry">
                <div className={`flex items-center justify-between gap-3 ${side === 'right' ? 'md:flex-row-reverse' : ''}`} data-id="element-71" data-mp="3er3hxb9bbn71">
                  <span className={`leaf-sm grid h-12 w-12 shrink-0 place-items-center ${highlight ? 'bg-forest text-mint' : 'bg-canvas text-forest'}`} data-id="element-72" data-mp="39tl8zkvap7z1">
                    <Icon className="h-5 w-5" data-id="element-73" data-mp="2vtabhyzhcv4w" />
                  </span>
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white px-3 py-1 text-xs font-semibold text-forest ring-1 ring-line" data-id="element-74" data-mp="2vu2739t2usv6">
                    {side === 'right' && <ArrowLeftIcon className="hidden h-3.5 w-3.5 md:block" data-id="element-75" data-mp="1g8hvth98gs3t" />}
                    {n.link}
                    {side === 'left' && <ArrowRightIcon className="hidden h-3.5 w-3.5 md:block" data-id="element-76" data-mp="1pb0vjshq2olu" />}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-xl font-bold tracking-tight text-ink" data-id="element-77" data-mp="sl9zvpxp2veg">{n.label}</h3>
                <p className="mt-1 text-sm font-semibold text-sage" data-id="element-78" data-mp="xj1u4qltatlt">{n.tagline}</p>
                <p className="mt-3 leading-relaxed text-muted" data-id="element-79" data-mp="11looay5ygqm6">{n.detail}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}